import {useState} from 'react';
import {Button, Nav, Offcanvas} from 'react-bootstrap';
import {
    Link,
    useLocation
} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList, faPowerOff, faBars} from "@fortawesome/free-solid-svg-icons";

import {useAuth} from "../providers/authprovider";
import {useMobileMode} from "../utils/useMobile";
import WorkButton from './WorkButton';

export default function Navigation(props) {
    const [showDrawer, setShowDrawer] = useState(false);
    const mobile = useMobileMode();
    let location = useLocation();
    const auth = useAuth();
    const {user} = auth;


    const handleLogout = () => {
        auth.signout();
    }; 

    const toggleDrawer = () => setShowDrawer(!showDrawer);

    const ENDPOINTS_ARRAY = [
        {endpoint:'clients', name:'Kontrahenci'},
        {endpoint:'buildings', name:'Obiekty'},
        {endpoint:'calendar', name:'Terminarz'},
        {endpoint:'protocols', name:'Protokoły'},
        {endpoint:'devices', name:'Urządzenia'},
        {endpoint:'workers', name:'Pracownicy'},
        {endpoint:'teams', name:'Ekipy'},
        {endpoint:'offers', name:'Oferty'},
        {endpoint:'offer_price_list', name:'Cennik'},
        {endpoint:'instructions', name:'Instrukcje'},
        {endpoint:'invoices', name:'Faktury'},
        {endpoint:'worktime', name:'Czas pracy'},
        {endpoint:'settings', name:'Ustawienia'},
    ];

    const isActive = (path) => location.pathname.startsWith(path) ? "active" : "";
    const currentSection = ENDPOINTS_ARRAY.find(e => location.pathname.startsWith(`/${e.endpoint}`))?.name || "";
    const getDesktopNavLinkStyle = (endpoint) => {
        const active = location.pathname.startsWith(`/${endpoint}`);

        return {
            fontSize: "0.9rem",
            paddingLeft: "0.45rem",
            paddingRight: "0.45rem",
            borderRadius: "0.35rem",
            backgroundColor: active ? "rgba(94, 115, 141, 0.14)" : "transparent",
        };
    };


    return (
        <>
            {/* Top App Bar */}
            <div className="d-flex align-items-center px-3 justify-content-between py-2 bg-light border-bottom shadow-sm w-100">
                {/* Left: Drawer toggle on mobile */}
                {mobile && (
                    <div className='d-flex justify-content-between align-items-center w-100'>
                    <Button variant="outline-secondary" onClick={toggleDrawer}>
                        <FontAwesomeIcon icon={faBars}/>
                    </Button>
                     <span className="ps-4 fw-semibold fs-6">{currentSection}</span>
                     <WorkButton />
                    </div>
                    
                )}

                {/* Center: Desktop nav */}
                {!mobile && (
                    <Nav  activeKey={location.pathname}>
                        {
                            ENDPOINTS_ARRAY.map(({endpoint, name}, pos) => {
                                const privilege = user?.getPrivilege(endpoint);
                                if (!privilege?.view) return null;

                                return (
                                    <Nav.Item key={`link-${pos}`}>
                                        <Link
                                            className={`nav-link ${isActive(`/${endpoint}`)}`}
                                            to={`/${endpoint}`}
                                            style={getDesktopNavLinkStyle(endpoint)}
                                        >
                                            {name}
                                        </Link>
                                    </Nav.Item>
                                );
                            })
                        }
                    </Nav>
                )}

                {/* Right: Desktop Action Icons */}
                {!mobile && (
                    <div className="d-flex align-items-center gap-2">
                        <WorkButton />
                        <Button variant="outline-info" title="TODO" onClick={props.onOpenTodo}>
                            <FontAwesomeIcon icon={faList}/>
                        </Button>
                        <Button variant="outline-warning" title="Wyloguj" onClick={handleLogout}>
                            <FontAwesomeIcon icon={faPowerOff}/> <b>{user?.name}</b>
                        </Button>
                    </div>
                )}
            </div>

            {/* Left Drawer (Offcanvas) for mobile */}
            <Offcanvas show={showDrawer} onHide={toggleDrawer} placement="start">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Nawigacja</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex flex-column h-100">
                    <Nav className="flex-column" activeKey={location.pathname}>
                        {
                            ENDPOINTS_ARRAY.map(({endpoint, name}, pos) => {
                                const privilege = user?.getPrivilege(endpoint);
                                if (!privilege?.view) return null;

                                return (
                                    <Nav.Item key={`drawer-link-${pos}`}>
                                        <Link
                                            className={`nav-link ${isActive(`/${endpoint}`)}`}
                                            to={`/${endpoint}`}
                                            onClick={toggleDrawer}
                                        >
                                            {name}
                                        </Link>
                                    </Nav.Item>
                                );
                            })
                        }
                    </Nav>

                    {/* Bottom Action Buttons */}
                    <div className="mt-auto pt-3 border-top d-flex justify-content-between">
                        <Button variant="outline-info" onClick={() => {
                            toggleDrawer();
                            props.onOpenTodo();
                        }}>
                            <FontAwesomeIcon icon={faList}/> TODO
                        </Button>
                        <Button variant="outline-warning" onClick={handleLogout}>
                            <FontAwesomeIcon icon={faPowerOff}/> {user?.name}
                        </Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}
